module.exports = __webpack_public_path__ + "img/SC.049e7208.svg";